import { Option } from '@cmg/common';

import { OfferingType } from '../../../../graphql';
import { offeringTypesOptions } from '../../../../types/domain/offering/constants';

type GetOfferingSetupTypeOptionsParams = {
  exclude?: OfferingType[];
};

export function getOfferingSetupTypesOptions({
  exclude = [],
}: GetOfferingSetupTypeOptionsParams = {}) {
  const excludedTypes = [OfferingType.Rights, OfferingType.RegisteredDirect, ...(exclude ?? [])];

  return offeringTypesOptions.filter(type => !excludedTypes.includes(type.value));
}

export const defaultParseFormikValue = <T>(value: unknown, options: readonly Option<T>[]) => {
  return options.find(option => option.value === value);
};
